<template>
  <el-form class="reset-password form-container" :rules="rules"
  ref="passwordsForm" :model="form" label-width="120px">
    <el-form-item label="原密码" prop="orignalPwd" required >
      <el-input type="password"  v-model="form.orignalPwd"></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="newPwd"  required>
      <el-input type="password"  v-model="form.newPwd"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="repeatPwd" required>
      <el-input type="password"  v-model="form.repeatPwd"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" size="small">确认</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { changePasswords } from '@/api/personal-center/setting';
import md5 from 'crypto-js/md5';

export default {
  name: 'reset-password',
  data() {
    const validateRepeatPwd = (rule, value, callback) => {
      if (value !== this.form.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      form: {
        orignalPwd: '',
        newPwd: '',
        repeatPwd: '',
      },
      rules: {
        orignalPwd: [{
          required: true,
          message: '请输入原密码',
          trigger: 'blur',
        }],
        newPwd: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur',
        }, {
          min: 6,
          message: '密码最少6位',
          trigger: 'blur',
        }],
        repeatPwd: [{
          required: true,
          message: '请重复输入密码',
          trigger: 'blur',
        }, {
          min: 6,
          message: '密码最少6位',
          trigger: 'blur',
        }, {
          validator: validateRepeatPwd, trigger: 'blur',
        }],
      },
    };
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId;
    },
  },
  methods: {
    onSubmit() {
      // const formData = new FormData();
      // formData.append('UIDstr', this.accountId);
      // formData.append('OldPasswordstr', md5(this.form.orignalPwd).toString());
      // formData.append('NewPasswordstr', md5(this.form.newPwd).toString());
      changePasswords({
        UIDstr: this.accountId,
        OldPasswordstr: md5(this.form.orignalPwd).toString(),
        NewPasswordstr: md5(this.form.newPwd).toString(),
      }).then(() => {
        this.$message({
          message: '修改密码成功！',
          type: 'success',
        });
        setTimeout(() => {
          this.$emit('changeResult', 1);
        }, 2000);
      });
    },
  },
};
</script>
<style scoped>
.form-container{
  padding:2% 5%;
}
</style>
